import { Fragment, useContext, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { OrderSummaryRowSkeleton } from "../../Skeleton/OrderSummaryRowSkeleton";
import { OrderSummaryList } from "./OrderSummaryList";
import { SHIPPING_METHOD } from "../../constants";
import { useAuth } from "../../Context/AuthContext";
import { GlobalContext } from "../../Context/GlobalContext";
import { useParams } from "react-router-dom";
import { axiosInstance } from "../../axios/axiosInstance";
import { OrderSummaryRow } from "./OrderSummaryRow";

export const OrderSummaryMain = ({ billInfo, payonline = true }) => {
  const { userId } = useAuth();
  const [cartItem, setCartItem] = useState(null);
  const [deliveryMethod, setDeliveryMethod] = useState(null);
  const globalcontext = useContext(GlobalContext);
  const [netAmount, setNetAmount] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [shipCost, setShipCost] = useState(0);
  const { orderId } = useParams();
  // useEffect(() => {
  //   if (orderId) {
  //     axiosInstance
  //       .post("MyCart/GetOrderItem", {
  //         UserID: String(userId),
  //         OrderID: String(orderId),
  //       })
  //       .then((response) => {
  //         setCartItem(response.data);
  //         setTotalTax(response.data.totaltax);
  //         setGrossAmount(response.data.totalcost);
  //         setNetAmount(response.data.totalIncTax);
  //       })
  //       .catch((error) => console.log(error.message));
  //   }
  // }, [orderId]);

  useEffect(() => {
    if (billInfo) {
      setCartItem(billInfo.orderItem);
      setTotalTax(billInfo.taxAmount);
      setNetAmount(billInfo.totalAmount);
      setShipCost(billInfo.shipCost);
    }
  }, [billInfo]);

  return (
    <div className="col-lg-12">
      <div className="orderCompleted-infoSummary">
        {payonline && <h2>Order Summary</h2>}
        <div className="checkout-orderSummary">
          {!payonline && <h2>Order Summary</h2>}
          <OrderSummaryRow cartItem={cartItem} />
          <div className="order-summary-total">
            <div className="orderSummary-list">
              <OrderSummaryList label={"Sub Total"} value={cartItem && cartItem.totalcost} />
              {deliveryMethod == SHIPPING_METHOD[3] ? (
                <></>
              ) : (
                parseInt(shipCost) != 0 && <OrderSummaryList label={"Shipping"} value={shipCost} />
              )}

              <OrderSummaryList label={"Tax Amount"} value={totalTax} />
            </div>
            <div className="orderSummary-total">
              <div className="order-summary-list">
                <p>Total</p>
                {payonline ? (
                  billInfo && billInfo.isTBA == true ? (
                    <span>TBA</span>
                  ) : netAmount ? (
                    <span>${netAmount.toFixed(2)}</span>
                  ) : (
                    <Skeleton width={50} height={28} />
                  )
                ) : netAmount ? (
                  <span>{`$ ${netAmount.toFixed(2)}`}</span>
                ) : (
                  <Skeleton width={50} height={28} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
